import { useInfoUser } from "../../store/UserStore";
import { useLabelStore } from "../../store/LabelStore";
import React, { useEffect, useState } from "react";
import apiFactory from "../../api";
import { toast } from "react-toastify";
import { Button, Divider, Input, Modal } from "antd";
import { FaSave, FaBars } from "react-icons/fa"; // CẬP NHẬT: Thêm FaBars
import { MdAddCircleOutline, MdEdit } from "react-icons/md";
import { AiFillDelete } from "react-icons/ai";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useMenuContext } from "../../context/MenuContext";
import { getColorFromInitial, openNotificationError } from "../../utils/Utils";
import { EditOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { BsTrash3Fill } from "react-icons/bs";

const LabelModal = ({
  selectedConversation,
  labelSelectedId,
  setLabelSelectedId,
  handleUpdateConversationList,
  conversationList,
  isModalLabelOpen,
  setIsModalLabelOpen,
}) => {
  const { languageMap } = useInfoUser();
  const { labelList, setLabelList } = useLabelStore();
  const [labels, setLabels] = useState(labelList);
  const [newLabel, setNewLabel] = useState("");

  const [isAdding, setIsAdding] = useState(false);

  useEffect(() => {
    setLabels(labelList);
  }, [labelList]);

  const cancelModal = () => {
    labelList?.map((label) => (label.isEdit = false));
    setIsAdding(false);
    setIsModalLabelOpen(false);
  };

  const deleteLabel = async (labelId) => {
    const response = await apiFactory.labelApi.deleteLabel(labelId);
    if (response.status === 200) {
      const index = labels.findIndex((s) => s?.labelId === labelId);

      if (index !== -1) {
        labels.splice(index, 1);
        setLabelList([...labels]);
        setLabels([...labels]);

        let updateConversation = conversationList?.filter(
          (cv) => cv?.labelId === labelId
        );

        if (updateConversation?.length > 0) {
          updateConversation.forEach((uc) => {
            uc.labelId = null;
          });

          handleUpdateConversationList([...conversationList]);
        }

        if (labelSelectedId === labelId) {
          setLabelSelectedId(null);
        }
      } else {
        openNotificationError(response?.message);
      }
    }
  };

  const addLabel = async () => {
    if (newLabel === null || newLabel.trim() === "") return;
    const req = {
      labelName: newLabel.trim(),
      userConversationId: selectedConversation?.userConversationId,
    };
    const res = await apiFactory.labelApi.createLabel(req);
    if (res?.status === 200) {
      const newLabelData = {
        ...res.data,
        value: res?.data?.labelId,
        label: res?.data?.labelName,
      };
      setLabelList([...labelList, newLabelData]);
      setLabels([...labels, newLabelData]);
      setNewLabel("");
      setIsAdding(false);
    } else {
      openNotificationError(res.message);
    }
  };

  const editLabel = (labelId) => {
    let label = labels?.find((label) => label?.labelId === labelId);
    label.isEdit = true;
    setLabels([...labels]);
  };

  const saveLabel = async (labelId) => {
    let label = labels?.find((label) => label?.labelId === labelId);

    const req = {
      labelName: label?.labelName,
      labelId: labelId,
    };
    const res = await apiFactory.labelApi.updateLabel(req);

    if (res?.status === 200) {
      label.value = res?.data?.labelId;
      label.label = res?.data?.labelName;

      setLabelList([...labels]);
      setLabels([...labels]);
      label.isEdit = false;
    } else {
      openNotificationError(res.message);
    }
  };

  const onChangeLabelName = (e, labelId) => {
    const updatedLabels = labels.map((label) => {
      if (label?.labelId === labelId) {
        return {
          ...label,
          labelName: e?.target?.value,
        };
      }
      return label;
    });
    setLabels(updatedLabels);
  };

  const generateLabelInput = (label) => {
    if (label?.isEdit) {
      return (
        <div
          className="flex items-center gap-[10px] p-2 bg-gray-100 rounded-md"
          key={label?.labelId}
        >
          <span className="cursor-grab text-gray-400 flex-shrink-0">
            <FaBars />
          </span>

          <Input
            className="flex-1"
            value={label?.labelName}
            maxLength={40}
            onChange={(e) => onChangeLabelName(e, label?.labelId)}
          />
          <div className="icon flex-shrink-0">
            <FaSave
              size={22}
              color="#539edf"
              className="cursor-pointer"
              onClick={() => saveLabel(label?.labelId)}
            />
          </div>
          <div className="icon flex-shrink-0">
            <AiFillDelete
              size={22}
              color="red"
              className="cursor-pointer"
              onClick={() => {
                deleteLabel(label?.labelId);
              }}
            />
          </div>
        </div>
      );
    }

    return (
      <div
        className="flex items-center gap-[10px] p-2 rounded-md hover:bg-gray-100 group"
        key={label?.labelId}
      >
        <span className="cursor-grab text-gray-400 flex-shrink-0">
          <FaBars />
        </span>
        <span className="flex-1 text-gray-800 truncate">
          {label?.labelName}
        </span>
        <div className="icon flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
          <Button
            className="cursor-pointer"
            onClick={() => editLabel(label?.labelId)}
            icon={<EditOutlined size={25} />}
            color="default"
            variant="text"
          />
        </div>
        <div className="icon flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
          <Button
            className="cursor-pointer"
            onClick={() => deleteLabel(label?.labelId)}
            icon={<BsTrash3Fill size={15} />}
            color="default"
            variant="text"
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      width="400px"
      open={isModalLabelOpen}
      footer={false}
      onCancel={cancelModal}
      title={
        languageMap?.["modal.labelManagement.title"] ?? "Quản lý thẻ phân loại"
      }
      closable={true}
    >
      <div>
        <div className="overflow-y-auto h-80 flex flex-col gap-[5px] pr-2">
          {labels?.map((label) => generateLabelInput(label))}
        </div>

        {isAdding ? (
          <>
            <hr />
            <div className="flex items-center gap-[10px] mt-2">
              <Input
                value={newLabel}
                className="flex-1"
                maxLength={40}
                onChange={(e) => setNewLabel(e?.target?.value)}
                onDragEnter={newLabel.trim() ? addLabel : null}
                placeholder={
                  languageMap?.["modal.labelManagement.placeholder"] ??
                  "Nhập tên thẻ phân loại"
                }
              />
              <Button
                className={`cursor-pointer bg-[#2a56b9] text-[white] ${
                  newLabel.trim() ? "" : "opacity-50 cursor-not-allowed"
                }`}
                onClick={newLabel.trim() ? addLabel : null}
                disabled={!newLabel.trim()}
                icon={<PlusOutlined size={25} color="blue" />}
              />
              <Button
                className={`cursor-pointer bg-[#ff0000] text-[white]`}
                onClick={() => setIsAdding(false)}
                icon={<MinusOutlined size={25} color="blue" />}
              />
            </div>
          </>
        ) : (
          <>
            <hr />
            <button
              className="flex items-center gap-[10px] p-2 rounded-md hover:bg-gray-100 mt-2"
              onClick={() => setIsAdding(true)}
            >
              <PlusOutlined size={20} />
              <span className="font-medium">
                {languageMap?.["modal.labelManagement.addLabel"] ??
                  "Thêm phân loại"}
              </span>
            </button>
          </>
        )}
      </div>
    </Modal>
  );
};
export { LabelModal };
